import React from 'react'

export const IconLine = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 33.668 33.668"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M33.668 16.834c0 1.934-1.566 3.5-3.5 3.5H3.5a3.5 3.5 0 110-7h26.668c1.934 0 3.5 1.566 3.5 3.5z" />
    </svg>
  )
}
